export const URL_REPLACEMENT = 'ar://';

export const TITLE_TRAIT_NUMBER = 'traitCount';

export const HIDEN_HONORARY_CHIMP_ID: string[] = [];

export const INVALID_OWNER = '0x0000000000000000000000000000000000000000';
